import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Link } from 'react-router-dom';

const VisionSection = () => {
  const [currentTestimonial, setCurrentTestimonial] = useState(0);

  const testimonials = [
    {
      id: 1,
      quote: "We had a dream for our forever home—and Vesta Designs brought it to life beautifully. Every space feels intentional, cozy, and truly ours. The team was patient, attentive, and incredibly talented.",
      author: "Thao Le",
      role: "Homeowner"
    },
    {
      id: 2,
      quote: "Working with Vesta Designs was an absolute pleasure. They understood our vision from day one and transformed our space beyond what we imagined possible. True professionals in every sense.",
      author: "John Doe",
      role: "Homeowner"
    },
    {
      id: 3,
      quote: "The attention to detail and creative solutions Vesta Designs provided exceeded all expectations. Our office space is now both functional and inspiring.",
      author: "Sarah Mitchell",
      role: "Business Owner"
    }
  ];

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentTestimonial((prev) => (prev + 1) % testimonials.length);
    }, 5000);

    return () => clearInterval(timer);
  }, [testimonials.length]);

  return (
    <section className="vision-section">
      {/* Left Panel - Vision */}
      <div className="vision-panel vision-left">
        <div 
          className="vision-bg"
          style={{ 
            backgroundImage: 'url(https://modarch.svb.la-studioweb.com/wp-content/uploads/2025/06/modarch-m4-s3-bg-a.jpg)' 
          }}
        />
        <div className="vision-overlay" />
        <div className="vision-content">
          <motion.span 
            className="vision-label"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
          >
            our vision
          </motion.span>
          <motion.p 
            className="vision-text"
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.2 }}
          >
            Bringing visions to life through innovative design and planning, 
            creating functional, aesthetic spaces for modern living, working, and lasting experiences.
          </motion.p>
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.4 }}
          >
            <Link to="/about" className="vision-btn">
              <span>Discover more</span>
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M5 12h14M12 5l7 7-7 7"/>
              </svg>
            </Link>
          </motion.div>
        </div>
      </div>

      {/* Right Panel - Testimonials */}
      <div className="vision-panel vision-right">
        <div 
          className="vision-bg"
          style={{ 
            backgroundImage: 'url(https://modarch.svb.la-studioweb.com/wp-content/uploads/2025/06/modarch-m4-s3-bg-b.jpg)' 
          }}
        />
        <div className="vision-overlay dark" />
        <div className="vision-content testimonial-content">
          <AnimatePresence mode="wait">
            <motion.div
              key={currentTestimonial}
              className="testimonial-item"
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -30 }}
              transition={{ duration: 0.5 }}
            >
              <svg className="quote-icon" viewBox="0 0 24 24" fill="currentColor">
                <path d="M14.017 21v-7.391c0-5.704 3.731-9.57 8.983-10.609l.995 2.151c-2.432.917-3.995 3.638-3.995 5.849h4v10h-9.983zm-14.017 0v-7.391c0-5.704 3.748-9.57 9-10.609l.996 2.151c-2.433.917-3.996 3.638-3.996 5.849h3.983v10h-9.983z"/>
              </svg>
              <p className="testimonial-quote">{testimonials[currentTestimonial].quote}</p>
              <div className="testimonial-author">
                <span className="author-name">{testimonials[currentTestimonial].author},</span>
                <span className="author-role">{testimonials[currentTestimonial].role}</span>
              </div>
            </motion.div>
          </AnimatePresence>

          {/* Testimonial Navigation */}
          <div className="testimonial-nav">
            {testimonials.map((_, index) => (
              <button
                key={index}
                className={`testimonial-dot ${index === currentTestimonial ? 'active' : ''}`}
                onClick={() => setCurrentTestimonial(index)}
                aria-label={`Testimonial ${index + 1}`}
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default VisionSection;
